import type { WizardFlowKind } from '../../utils/wizardCategoryRoute';
import TaskCaseUpdateTab from './TaskCaseUpdateTab';
import TaskCaseCivilAdviseUpdateTab from './TaskCaseCivilAdviseUpdateTab';
import TaskCaseNominationUpdateTab from './TaskCaseNominationUpdateTab';
import TaskCaseRightToInformationUpdateTab from './TaskCaseRightToInformationUpdateTab';
import TaskCaseCivilLitigationUpdateTab from './TaskCaseCivilLitigationUpdateTab';
import TaskCaseCivilAppellateUpdateTab from './TaskCaseCivilAppellateUpdateTab';
import TaskCaseCriminalAppellateUpdateTab from './TaskCaseCriminalAppellateUpdateTab';
import TaskCaseExtraditionMlaUpdateTab from './TaskCaseExtraditionMlaUpdateTab';
import TaskCasePublicPetitionUpdateTab from './TaskCasePublicPetitionUpdateTab';
import TaskCaseAttorneyGeneralUpdateTab from './TaskCaseAttorneyGeneralUpdateTab';

type Props = {
  flow: WizardFlowKind;
  caseRequestId: string;
  recentSubmittedAt: string;
  readOnly?: boolean;
  /** Called after the user confirms cancel — typically switches to Case Details tab. */
  onCancelConfirmed?: () => void;
};

/**
 * Case Update tab router. Each flow tab fetches its own latest view data on mount
 * so opening this tab (including revisits) always loads fresh update details.
 */
export default function TaskCaseUpdateTabRouter({
  flow,
  caseRequestId,
  recentSubmittedAt,
  readOnly = false,
  onCancelConfirmed,
}: Props) {
  const common = {
    caseRequestId,
    recentSubmittedAt,
    readOnly,
    onCancelConfirmed,
  };

  switch (flow) {
    case 'criminal':
      return <TaskCaseUpdateTab {...common} />;
    case 'civil-advise':
      return <TaskCaseCivilAdviseUpdateTab {...common} />;
    case 'nomination-requests':
      return <TaskCaseNominationUpdateTab {...common} />;
    case 'right-to-information':
      return <TaskCaseRightToInformationUpdateTab {...common} />;
    case 'civil-litigation':
      return <TaskCaseCivilLitigationUpdateTab {...common} />;
    case 'civil-appellate':
      return <TaskCaseCivilAppellateUpdateTab {...common} />;
    case 'criminal-appellate':
      return <TaskCaseCriminalAppellateUpdateTab {...common} />;
    case 'extradition-mla':
      return <TaskCaseExtraditionMlaUpdateTab {...common} />;
    case 'public-petition':
      return <TaskCasePublicPetitionUpdateTab {...common} />;
    case 'attorney-general':
      return <TaskCaseAttorneyGeneralUpdateTab {...common} />;
    default:
      return (
        <p className="tcd-update-ts" style={{ color: 'var(--t2)' }}>
          Case update is not available for this case type.
        </p>
      );
  }
}
